import React from "react";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";

export default function Editor({ onChange, initialValue, ...otherProps }) {
  const { quill, quillRef } = useQuill();

  React.useEffect(() => {
    if (!quill) return;

    const handleChange = () => {
      const content = quill.root.innerHTML;
      onChange(content);
    };

    quill.on("text-change", handleChange);

    return () => {
      quill.off("text-change", handleChange);
    };
  }, [quill]);

  React.useEffect(() => {
    if (quill && initialValue) {
      quill.root.innerHTML = initialValue;
    }
  }, [quill]);

  return (
    // agregar otras propiedades al div padre
    <div
      {...otherProps}
      style={{
        height: "300px",
        width: "100%",
      }}
    >
      <div ref={quillRef} />
    </div>
  );
}
